import peImage from 'images/Img_Dashboard_PE.jpg';
import musicImage from 'images/Img_Dashboard_Music.jpg';
import { SubjectTypes } from 'pages/dashboard/models';

export const getSubjectImage = (subject: SubjectTypes) => {
  switch (subject) {
    case 'Get Set 4 Music':
      return musicImage;

    case 'Get Set 4 PE':
      return peImage;

    default:
      return '';
  }
};
